import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles, TrendingUp, Zap } from "lucide-react";

const sources = [
  "Reddit r/BuyItForLife", "TikTok Shop", "Etsy Surges", "Pinterest Trends",
  "AliExpress Movers", "Amazon Movers & Shakers", "Google Patents", "Shopify Apps",
  "ProductHunt", "Substack Niches", "Discord Servers", "Twitter/X Bookmarks",
  "Kickstarter Funded", "Indie Hackers", "YouTube Shorts", "App Store Top",
];

const Hero = () => (
  <section id="hero" className="relative pt-32 pb-24 overflow-hidden bg-hero-radial">
    <div className="absolute inset-0 bg-grid pointer-events-none" />
    <div className="container relative">
      <div className="max-w-4xl mx-auto text-center animate-float-up">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-border bg-card/60 backdrop-blur text-xs font-mono text-muted-foreground mb-8">
          <span className="relative flex w-2 h-2">
            <span className="absolute inset-0 rounded-full bg-primary animate-pulse-dot" />
            <span className="relative rounded-full w-2 h-2 bg-primary" />
          </span>
          LIVE — Scanning 35+ secret sources right now
        </div>

        <h1 className="font-display text-5xl md:text-7xl lg:text-8xl font-bold leading-[0.95] tracking-tight">
          You're <span className="text-gradient-primary">six months late</span>
          <br />
          to every trend.
        </h1>

        <p className="mt-8 text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
          Trends Discovery is the AI that scans 35+ underground sources in real-time
          to surface tomorrow's best-selling niches — and hands you the complete
          blueprint to launch them before anyone else notices.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center items-center">
          <Button variant="hero" size="xl" asChild>
            <a href="#pricing">
              Get My First 10 Trends <ArrowRight />
            </a>
          </Button>
          <Button variant="outlineHero" size="xl" asChild>
            <Link to="/marketplace">Browse blueprints — from $9</Link>
          </Button>

        </div>

        <div className="mt-6 text-xs font-mono text-muted-foreground">
          One-time payment · Lifetime access · No subscription
        </div>
      </div>

      {/* Floating dashboard mock */}
      <div className="relative max-w-5xl mx-auto mt-20">
        <div className="absolute -inset-4 bg-primary/20 blur-3xl rounded-full opacity-50" />
        <div className="relative rounded-2xl border border-border bg-card/80 backdrop-blur-xl shadow-elevated overflow-hidden">
          <div className="flex items-center gap-2 px-4 py-3 border-b border-border bg-secondary/40">
            <div className="flex gap-1.5">
              <span className="w-2.5 h-2.5 rounded-full bg-destructive/60" />
              <span className="w-2.5 h-2.5 rounded-full bg-accent/60" />
              <span className="w-2.5 h-2.5 rounded-full bg-primary/60" />
            </div>
            <span className="ml-3 font-mono text-xs text-muted-foreground">trends.discovery / dashboard</span>
          </div>
          <div className="grid md:grid-cols-3 gap-px bg-border">
            {[
              { tag: "RISING +847%", title: "Silent walking sticks for trail runners", icon: TrendingUp, src: "Reddit · TikTok" },
              { tag: "EARLY SIGNAL", title: "Sleep-tracked toddler nightlights", icon: Sparkles, src: "Etsy · Pinterest" },
              { tag: "BLUEPRINT READY", title: "AI dream-journal printables", icon: Zap, src: "Substack · Discord" },
            ].map((item, i) => (
              <div key={i} className="bg-card p-6 hover:bg-secondary/40 transition-colors">
                <div className="flex items-center justify-between mb-4">
                  <span className="font-mono text-[10px] tracking-wider text-primary">{item.tag}</span>
                  <item.icon className="w-4 h-4 text-muted-foreground" />
                </div>
                <h2 className="font-display font-semibold text-lg leading-snug mb-3">{item.title}</h2>
                <div className="font-mono text-xs text-muted-foreground">src: {item.src}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>

    {/* Sources ticker */}
    <div className="mt-20 ticker-mask overflow-hidden">
      <div className="flex gap-12 animate-ticker w-max">
        {[...sources, ...sources].map((s, i) => (
          <span key={i} className="font-mono text-sm text-muted-foreground whitespace-nowrap">
            ◆ {s}
          </span>
        ))}
      </div>
    </div>
  </section>
);

export default Hero;
